import type { DateTime } from "luxon";

/** PostgreSQL's `prevent_24hour_shifts` constraint is exclusive: an open shift must be shorter than this. */
export const MAX_OPEN_SHIFT_DURATION_HOURS = 24;

/**
 * Uses elapsed time (UTC instants), matching PostgreSQL's timestamptz subtraction across DST changes.
 * Ordering is intentionally left to the caller because some generic time pickers allow a zero-length
 * draft while open-shift write surfaces require end > start.
 */
export const isShiftDurationBelowHours = (start: DateTime, end: DateTime, maximumHours: number): boolean =>
	end.toUTC().diff(start.toUTC(), "hours").hours < maximumHours;

/**
 * The database invariant only has an exclusive upper bound. Keep this separate from selectable
 * range validation because the medical posting flow intentionally sends a zero-length placeholder.
 */
export const isOpenShiftBelowMaximumDuration = (start: DateTime, end: DateTime): boolean =>
	start.isValid && end.isValid && isShiftDurationBelowHours(start, end, MAX_OPEN_SHIFT_DURATION_HOURS);

export const isOpenShiftDurationAllowed = (start: DateTime, end: DateTime): boolean => end > start && isOpenShiftBelowMaximumDuration(start, end);
